<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    background
    :size="size"
    :current-page="currentPage"
    :page-sizes="pageSizes"
    :page-size="limit"
    :layout="layout"
    :total="total">
  </el-pagination>
</template>
<script>
export default {
  name: 'TablePagination',
  props: {
    size: {
      type: String,
      default: 'small'
    },
    total: Number,
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => ([10, 20, 50])
    },
    currentPage: Number
  },
  data() {
    return {
      page: 1,
      limit: 10
    }
  },
  methods: {
    handleSizeChange(size) {
      this.limit = size;
      this.page = 1;
      this.handleChange(1, size);
      this.handleUpdate(1, size);
    },
    handleCurrentChange(page) {
      this.page = page;
      this.handleUpdate(page, this.limit);
      this.handleChange(page, this.limit);
    },
    handleChange(page, size) {
      this.$emit('change', page, size);
    },
    handleUpdate(page = 1, size = 10) {
      this.$emit('update:page-size', size);
      this.$emit('update:current-page', page);
    }
  }
}
</script>
